import React, { useState, useEffect } from 'react';
import api from '@/lib/api';

const ContactEditor = () => {
    const [content, setContent] = useState({
        email: '',
        phone: '',
        address: '',
        instagram: '',
        twitter: '',
        linkedin: ''
    });
    const [loading, setLoading] = useState(true);
    const [message, setMessage] = useState('');

    useEffect(() => {
        const fetchContent = async () => {
            try {
                const { data } = await api.get('/sections/Contact');
                if (data && data.content) {
                    const contentMap = {};
                    data.content.forEach(item => contentMap[item.key] = item.value);
                    setContent(prev => ({ ...prev, ...contentMap }));
                }
                setLoading(false);
            } catch (error) {
                console.error(error);
                setLoading(false);
            }
        };
        fetchContent();
    }, []);

    const handleChange = (e) => {
        setContent({ ...content, [e.target.name]: e.target.value });
    };

    const handleSave = async () => {
        try {
            const contentArray = Object.keys(content).map(key => ({
                key, type: 'text', value: content[key]
            }));
            await api.put('/sections/Contact', { content: contentArray });
            setMessage('Contact section updated successfully!');
            setTimeout(() => setMessage(''), 3000);
        } catch (error) {
            setMessage('Error saving contact section');
        }
    };

    if (loading) return <div>Loading...</div>;

    return (
        <div className="max-w-4xl mx-auto bg-white p-8 rounded shadow text-gray-900">
            <h2 className="text-2xl font-bold mb-6">Edit Contact Section</h2>
            {message && <div className={`p-4 mb-4 rounded ${message.includes('Error') ? 'bg-red-100 text-red-700' : 'bg-green-100 text-green-700'}`}>{message}</div>}

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div>
                    <h3 className="font-semibold mb-3">General Info</h3>
                    <div className="space-y-4">
                        <div>
                            <label className="block text-sm font-medium text-gray-700">Email</label>
                            <input
                                type="email" name="email" value={content.email} onChange={handleChange}
                                className="w-full mt-1 p-2 border rounded"
                            />
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-gray-700">Phone</label>
                            <input
                                type="text" name="phone" value={content.phone} onChange={handleChange}
                                className="w-full mt-1 p-2 border rounded"
                            />
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-gray-700">Address</label>
                            <textarea
                                name="address" value={content.address} onChange={handleChange}
                                className="w-full mt-1 p-2 border rounded h-24"
                            />
                        </div>
                    </div>
                </div>

                <div>
                    <h3 className="font-semibold mb-3">Social Links</h3>
                    <div className="space-y-4">
                        <div>
                            <label className="block text-sm font-medium text-gray-700">Instagram URL</label>
                            <input
                                type="text" name="instagram" value={content.instagram} onChange={handleChange}
                                className="w-full mt-1 p-2 border rounded"
                            />
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-gray-700">Twitter (X) URL</label>
                            <input
                                type="text" name="twitter" value={content.twitter} onChange={handleChange}
                                className="w-full mt-1 p-2 border rounded"
                            />
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-gray-700">LinkedIn URL</label>
                            <input
                                type="text" name="linkedin" value={content.linkedin} onChange={handleChange}
                                className="w-full mt-1 p-2 border rounded"
                            />
                        </div>
                    </div>
                </div>
            </div>

            <button onClick={handleSave} className="mt-8 px-6 py-2 bg-black text-white rounded hover:bg-gray-800">
                Save Changes
            </button>
        </div>
    );
};

export default ContactEditor;
